<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_BTNS.nuevo}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [innTemplate]="abrirModal"
                [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="agregarForm" mat-dialog-content>
      <div class="row">
        <div class="col-lg-6">
          <div class="row">
            <div *ngIf="!isCreate" class="col-lg-12 mb-2">
              <label for="">Id tipo Orden</label>
              <input class="form-control" formControlName="id" type="text">
            </div>
            <div class="col-lg-12 mb-2">
              <label class="mb-2" for="reqOrden">
                Requiere Orden
              </label>
              <div class="form-check">
                <input (change)="validaciones()" class="form-check-input" formControlName="reqOrden" id="reqOrden"
                       type="checkbox">
                <label class="form-check-label" for="reqOrden">
                  {{this.agregarForm.get('reqOrden').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>
            <div class="col-lg-12 mb-2">
              <label for="">Tipo de Tolerancia</label>
              <select class="form-control" formControlName="tipoTolerancia">
                <option selected value="0">Kilos</option>
                <option value="1">Porcentaje</option>
                <option value="2">No Aplica</option>
              </select>
              <small *ngIf="agregarForm.get('granel')?.hasError('required')" class="text-danger">*Este
                campo es requerido</small>
            </div>

            <div class="col-lg-12 mb-2">
              <label class="mb-2" for="ingresa">
                Ingresa Vehículo vacío
              </label>
              <div class="form-check">
                <input class="form-check-input" formControlName="ingresa" id="ingresa" type="checkbox">
                <label class="form-check-label" for="ingresa">
                  {{this.agregarForm.get('ingresa').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>

            <div *ngIf="agregarForm.get('tipOrden').value == 1 || agregarForm.get('tipOrden').value == 2" class="col-lg-12 mb-2">
              <label class="mb-2" for="prePesaje">Pre-Pesaje. Activa el peso sin orden y no valida diferencias</label>
              <div class="form-check">
                <input class="form-check-input" formControlName="prePesaje" id="prePesaje" type="checkbox">
                <label class="form-check-label" for="prePesaje">{{this.agregarForm.get('prePesaje').value ? 'Si' : 'No'}}</label>
              </div>
            </div>

            <div class="col-lg-12 mb-2">
              <label class="mb-2" for="reCaptura">Re-Captura Peso salida. Solicita un motivo obligatorio</label>
              <div class="form-check">
                <input class="form-check-input" formControlName="reCaptura" id="reCaptura" type="checkbox">
                <label class="form-check-label" for="reCaptura">{{this.agregarForm.get('reCaptura').value ? 'Si' : 'No'}}</label>
              </div>
            </div>

            <div class="col-lg-12 mb-2">
              <label class="mb-2" for="paramCalidad">
                Ingreso obligatorio parámetros calidad
              </label>
              <div class="form-check">
                <input (change)="validaciones()" class="form-check-input" formControlName="paramCalidad"
                       id="paramCalidad" type="checkbox">
                <label class="form-check-label" for="paramCalidad">
                  {{this.agregarForm.get('paramCalidad').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>
            <div class="col-lg-12 mb-2">
              <label class="mb-2" for="inspec">
                Genera Lote Inspección SAP
              </label>
              <div class="form-check">
                <input (change)="validaciones()" class="form-check-input" formControlName="inspec" id="inspec"
                       type="checkbox">
                <label class="form-check-label" for="inspec">
                  {{this.agregarForm.get('inspec').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>
            <div *ngIf="agregarForm.get('tipOrden').value == 0" class="col-lg-12 mb-2">
              <label class="mb-2" for="gradoApi">
                Aplica GRADO API
              </label>
              <div class="form-check">
                <input class="form-check-input" formControlName="gradoApi" id="gradoApi" type="checkbox" value="">
                <label class="form-check-label" for="gradoApi">
                  {{this.agregarForm.get('gradoApi').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>
            <div *ngIf="agregarForm.get('tipOrden').value == 0" class="col-lg-12 mb-2">
              <label class="mb-2" for="oriFlete">
                Aplica Orígenes/Fletes
              </label>
              <div class="form-check">
                <input class="form-check-input" formControlName="oriFlete" id="oriFlete" type="checkbox" value="">
                <label class="form-check-label" for="oriFlete">
                  {{this.agregarForm.get('oriFlete').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>
            <div class="col-lg-12 mb-2">
              <label class="mb-2" for="premiCastigo">
                Aplica Premio y Castigo
              </label>
              <div class="form-check">
                <input (change)="validaciones()" class="form-check-input" formControlName="premiCastigo"
                       id="premiCastigo" type="checkbox" value="">
                <label class="form-check-label" for="premiCastigo">
                  {{this.agregarForm.get('premiCastigo').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>
            <div class="col-lg-12 mb-2">
              <label class="mb-2" for="generaOcAuto">
                Genera OC automática
              </label>
              <div class="form-check">
                <input (change)="validaciones()" class="form-check-input" formControlName="generaOcAuto"
                       id="generaOcAuto" type="checkbox">
                <label class="form-check-label" for="generaOcAuto">
                  {{this.agregarForm.get('generaOcAuto').value ? 'Si' : 'No'}}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6">

          <div class="col-lg-12 mb-2">
            <label for="">Descripcion</label>
            <input (change)="trimStringDesc()" (keyup)="trimStringDesc()" class="form-control" formControlName="desca"
                   type="text">
            <small *ngIf="agregarForm.get('desca')?.hasError('required')" class="text-danger">*Este
              campo es
              requerido</small>
            <small *ngIf="agregarForm.get('desca')?.hasError('maxlength')" class="text-danger">
              *Máximo 50 caracteres</small>
          </div>
          <div class="col-lg-12 mb-2">
            <label for="">Tipo de Orden</label>
            <select (change)="validaciones()" class="form-control" formControlName="tipOrden">
              <option value="">-- Seleccione --</option>
              <option value="0">Compra</option>
              <option value="1">Venta</option>
              <option value="2">Traslado</option>
              <option value="3">Informativo</option>
              <option value="4">Maquila</option>
            </select>
            <small *ngIf="agregarForm.get('tipOrden')?.hasError('required')" class="text-danger">*Este
              campo es
              requerido</small>
          </div>
          <div class="col-lg-12 mb-2">
            <label for="">Valor Tolerancia</label>
            <input (change)="trimStringTole()" (keyup)="trimStringTole()" class="form-control"
                   formControlName="tolerancia" type="text">
            <small *ngIf="agregarForm.get('tolerancia')?.hasError('required')" class="text-danger">*Este
              campo es
              requerido</small>
            <small
              *ngIf="!agregarForm.get('tolerancia')?.hasError('required') && agregarForm.get('tolerancia')?.hasError('pattern')"
              class="text-danger">*Este
              Formato inválido (Ejm: 12)</small>
          </div>
          <div class="col-lg-12 mb-2">
            <label for="clasePerdido">CLASE DE PEDIDO</label>
            <input (change)="trimString()" (keyup)="trimString()" class="form-control" formControlName="clasePerdido"
                   type="text">
            <small *ngIf="agregarForm.get('clasePerdido')?.hasError('required')" class="text-danger">*Este
              campo es
              requerido</small>
            <small *ngIf="agregarForm.get('clasePerdido')?.hasError('maxlength')" class="text-danger">
              *Máximo 4 caracteres</small>
          </div>
          <div class="col-lg-12 mb-2">
            <label for="orgCompra">ORGANIZACIÓN DE COMPRA</label>
            <input (change)="trimString()" (keyup)="trimString()" class="form-control" formControlName="orgCompra"
                   type="text">
            <small *ngIf="agregarForm.get('orgCompra')?.hasError('required')" class="text-danger">*Este
              campo es
              requerido</small>
          </div>
          <div class="col-lg-12 mb-2">
            <label for="grupoCompra">GRUPO DE COMPAS</label>
            <input (change)="trimString()" (keyup)="trimString()" class="form-control" formControlName="grupoCompra"
                   type="text">
            <small *ngIf="agregarForm.get('grupoCompra')?.hasError('required')" class="text-danger">*Este
              campo es
              requerido</small>
          </div>
        </div>
      </div>
      <div *ngIf="errorBothOrderCheck" class="text-danger">
        Genera OC automática y requiere Orden no pueden estar ambas activas.
      </div>
      <div *ngIf="errorPremiosCastigosCheck" class="text-danger">
        Aplica premios y castigos, no puede estar activo sin que este activo Ingreso obligatorio de parámetros de
        calidad.
      </div>
      <div *ngIf="errorLoteInspeccionCheck" class="text-danger">
        Si se activa Genera Lote de Inspección debe estar activo Ingreso obligatorio de parámetros de calidad.
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
                                   [formularioValido]="(!agregarForm.invalid && !errorGeneral) ? false : true"
                                   [loading]="loading"
                                   [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
